import { render, staticRenderFns } from "./MaterialKatalogAuswahl.vue?vue&type=template&id=d9bbc43e&"
import script from "./MaterialKatalogAuswahl.vue?vue&type=script&lang=js&"
export * from "./MaterialKatalogAuswahl.vue?vue&type=script&lang=js&"
import style0 from "./MaterialKatalogAuswahl.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports